(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodDepartmentsItem', sodDepartmentsItem);

    function sodDepartmentsItem($compile, $templateCache) {
        return {
            restrict: 'E',
            scope: {
                removeItem: '&?',
                department: '=',
                options: '=?',
                type: '@?',
            },
            // templateUrl: function(elem, attrs) {
            //     if (attrs.template) {
            //         return attrs.template;
            //     }
            //
            //     return 'common/components/departments-item';
            // },
            link: function(scope, elem, attr, ctrl) {
                scope.readonly = true

                scope.item.label = scope.department[scope.options.schema.label];

                if (typeof scope.removeItem === typeof function() {}) {
                    scope.readonly = false;
                }
            },
            controller: sodDepartmentsItemCtrl,
        };
    }

    function sodDepartmentsItemCtrl($scope, $compile, $templateCache, lodash, $element) {
        this.$onInit = function() {
            $scope.item = {
                showTooltip: showTooltip,
            };

            var type = !!$scope.type ? $scope.type : 'default';
            var templateUrl = lodash.get($scope.options, 'itemTemplateUrl.' + type, 'common/components/departments-item');

            var template = $templateCache.get(templateUrl);

            $element.html(template);

            var compileScope = $scope;
            var cloneElement = $compile($element.contents())(compileScope);

            $scope.$on('$destroy', function() {
                cloneElement.off();
            });
        }

        function showTooltip() {
            if ($scope.item.label.length > 12) {
                return true;
            }
            return false;
        }
    }
})();